import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/TarotReading.tsx");
